const executeCartQuery = (query, variables) => {
  if (!window.storefrontApi) {
    console.error("storefrontApi is not defined on window");
  }
  return window.storefrontApi({
      method: "POST",
      data: JSON.stringify({ query, variables }),
  })
  .then((res) => {
      if (res.errors) {
          console.error("API Errors:", res.errors);
      }
      return res.data;
  })
  .catch((err) => {
      console.error("Network or API error:", err);
      throw err;
  });
};


const fetchCart = (gid) => {
  const query = `query retrieveCart($id: ID!) {
      cart(id: $id) {
          ${window.fragment.CART_FRAGMENT}
      }
  }`;
  return executeCartQuery(query, { id: gid });
};

const updateCart = (gid, lines) => {
  const query = `mutation ($id: ID!, $lines: [CartLineUpdateInput!]!) {
      cartLinesUpdate(cartId: $id, lines: $lines) {
          cart {
              ${window.fragment.CART_FRAGMENT}
          }
          userErrors {
              field
              message
              code
          }
          warnings {
              target
              message
              code
          }
      }
  }`;
  return executeCartQuery(query, { id: gid, lines }).then((data) => {
    const userErrors = data.cartLinesUpdate.userErrors;
    if (userErrors && userErrors.length > 0) {
        console.error("User Errors:", userErrors);
        throw new Error("Cart update failed due to user errors");
    }
    return data.cartLinesUpdate.cart;
});};

const discountCodeUpdate = (gid, discountCodes = []) => {
  const query = `mutation ($id: ID!, $discountCodes: [String!]!) {
      cartDiscountCodesUpdate(cartId: $id, discountCodes: $discountCodes) {
          cart {
              ${window.fragment.CART_FRAGMENT}
          }
          userErrors {
              field
              message
              code
          }
          warnings {
              target
              message
              code
          }
      }
  }`;

  return executeCartQuery(query, { id: gid, discountCodes });

};



window.CartStorefrontAPI = {
    fetch: fetchCart,
    update: updateCart,
    discountCodeUpdate: discountCodeUpdate,
};

